// extracted by mini-css-extract-plugin
module.exports = {"auctionImage":"AuctionPlayer_auctionImage__6MmK9","auctionCover":"AuctionPlayer_auctionCover__3BNOF"};